<div class="ui-page-shell">
  <app-ui-sidebar
    [menuSections]="menuSections"
    [activePath]="activePath"
    [collapsed]="sidebarCollapsed"
    [logoText]="logoText"
    [companyName]="companyName"
    [appName]="appSubtitle"
    (navigate)="onNavigate($event)">
  </app-ui-sidebar>

  <div class="ui-page-shell__main" [class.ui-page-shell__main--collapsed]="sidebarCollapsed">
    <app-ui-app-header
      [title]="title"
      [breadcrumbs]="breadcrumbs"
      [appName]="appName"
      [user]="user"
      (menuToggle)="onSidebarToggle()"
      (logout)="onLogout()">
    </app-ui-app-header>
    <main class="ui-page-shell__content">
      <ng-content></ng-content>
    </main>
  </div>
</div>
